<template>
    <div v-if="trained" class="trained">
        <div class="trained-value">{{ trained }}</div>
        <div class="trained-label">{{ $t('childes') }}<br>{{ $t('was_trained') }}</div>
    </div>
</template>

<script>
    export default {
        name: 'CourseTrained',

        props: {
            trained: {
                type: [String, Object, Number]
            }
        },
    }
</script>

<style scoped>

    .trained-value {
        font-size: 40px;
        font-family: "Manrope Bold";
        color: #ed1c24;
        display: inline-block;
        margin-right: 10px;
    }

    .trained-label {
        font-size: 18px;
        line-height: 18px;
        color: #231c37;
        display: inline-block;
    }

    .trained {
        background-color: #ffdb00;
        border-radius: 15px;
        padding: 4px 20px;
        box-shadow: 0px 0px 19px 3px #f5f17b;
        min-width: 280px;
        margin: 0 auto;
    }


</style>
